import Vue from "vue";
import VueRouter from "vue-router";
import store from '@/store/index.js';
import ItemList from "@/components/custom/item/ItemList";
import ItemCreate from "@/components/custom/item/ItemCreate";
import ItemImport from "@/components/custom/item/ItemImport";
import ItemDetail from "@/components/custom/item/ItemDetail";
import ItemEdit from "@/components/custom/item/ItemEdit";
import TermCreate from "@/components/custom/term/TermCreate";
import TermEdit from "@/components/custom/term/TermEdit";
import PeriodList from "@/components/custom/academic_period/PeriodList";
import PeriodCreate from "@/components/academic_period/PeriodCreate";
import PeriodEdit from "@/components/custom/academic_period/PeriodEdit";
import PeriodDetail from "@/components/custom/academic_period/PeriodDetail";
import EnrollmentPaymentCreate from "@/components/custom/payment/EnrollmentPaymentCreate";
import EnrollmentPaymentEdit from "@/components/custom/payment/EnrollmentPaymentEdit";
import EnrollmentInvoiceCreate from "@/components/custom/payment/EnrollmentInvoiceCreate";
import EnrollmentInvoiceEdit from "@/components/custom/payment/EnrollmentInvoiceEdit";
import CampusGradeCreate from "@/components/campus_grade/CampusGradeCreate";
import CampusGradeEdit from "@/components/campus_grade/CampusGradeEdit";
import CampusGradeList from "@/components/custom/campus_grade/CampusGradeList";
import CampusGradeImport from "@/components/custom/campus_grade/CampusGradeImport";
import GradeFeeCreate from "@/components/custom/grade_fee/GradeFeeCreate";
import GradeFeeEdit from "@/components/custom/grade_fee/GradeFeeEdit";
import GradeFeeDetail from "@/components/custom/grade_fee/GradeFeeDetail";
import GradeFeeImport from "@/components/custom/grade_fee/GradeFeeImport";
import GradeFeeList from "@/components/custom/grade_fee/GradeFeeList";
import ClassList from "@/components/custom/class/ClassList";
import ClassCreate from "@/components/custom/class/ClassCreate";
import ClassImport from "@/components/custom/class/ClassImport";
import ClassEdit from "@/components/custom/class/ClassEdit";
import ClassDetail from "@/components/custom/class/ClassDetail";
import TransactionList from "@/components/custom/transaction/TransactionList";
import TransactionCategoryList from "@/components/custom/transaction_category/TransactionCategoryList";
import TransactionCategoryCreate from "@/components/custom/transaction_category/TransactionCategoryCreate";
import TransactionCategoryEdit from "@/components/custom/transaction_category/TransactionCategoryEdit";
import TransactionCategoryDetail from "@/components/custom/transaction_category/TransactionCategoryDetail";
import TimetableList from "@/components/custom/timetable/TimetableList";
import TimetableCreate from "@/components/custom/timetable/TimetableCreate";
import TimetableImport from "@/components/custom/timetable/TimetableImport";
import TimetableDetail from "@/components/custom/timetable/TimetableDetail";
import TimetableEdit from "@/components/custom/timetable/TimetableEdit";
import TimetableTemplateList from "@/components/custom/timetable_template/TimetableTemplateList";
import TimetableTemplateCreate from "@/components/custom/timetable_template/TimetableTemplateCreate";
import TimetableTemplateEdit from "@/components/custom/timetable_template/TimetableTemplateEdit";
import TimetableTemplateDetail from "@/components/custom/timetable_template/TimetableTemplateDetail";
import ApplicantList from "@/components/custom/applicant/ApplicantList";
import ApplicantDetail from "@/components/custom/applicant/ApplicantDetail";
import AssignmentCreate from "@/components/assignment/assignmentCreate";
import AssignmentDetail from "@/components/assignment/assignmentDetail";
import AssignmentEdit from "@/components/assignment/assignmentEdit";
import AssignmentList from "@/components/custom/assignment/assignmentList";
import AttendanceRateList from "@/components/custom/attendance_rate/AttendanceRateList";
import AttendanceStudentList from "@/components/custom/attendance_student/AttendanceStudentList";
import AttendanceStudentCreate from "@/components/attendance_student/AttendanceStudentCreate";
import AttendanceStudentDetail from "@/components/attendance_student/AttendanceStudentDetail";
import AttendanceStudentEdit from "@/components/attendance_student/AttendanceStudentEdit";
import CourseCreate from "@/components/custom/course/CourseCreate";
import CourseDetail from "@/components/course/CourseDetail";
import CourseEdit from "@/components/custom/course/CourseEdit";
import CourseImport from "@/components/course/CourseImport";
import CourseList from "@/components/custom/course/CourseList";
import ExamCreate from "@/components/custom/exam/ExamCreate";
import ExamDetail from "@/components/custom/exam/ExamDetail";
import ExamEdit from "@/components/custom/exam/ExamEdit";
import ExamImport from "@/components/custom/exam/ExamImport";
import ExamList from "@/components/custom/exam/ExamList";
import GradingCreate from "@/components/custom/grading/GradingCreate";
import GradingDetail from "@/components/custom/grading/GradingDetail";
import GradingEdit from "@/components/custom/grading/GradingEdit";
import GradingImport from "@/components/custom/grading/GradingImport";
import GradingList from "@/components/custom/grading/GradingList";
import ReportCardGradingList from "@/components/custom/report_card_grading/ReportCardGradingList";
import ReportCardGradingDetail from "@/components/custom/report_card_grading/ReportCardGradingDetail";
import ReportCardGradingImport from "@/components/custom/report_card_grading/ReportCardGradingImport";
import ReportCardGradingEdit from "@/components/custom/report_card_grading/ReportCardGradingEdit";
import StudentList from "@/components/custom/student/StudentList";
import StudentCreate from "@/components/custom/student/StudentCreate";
import StudentEdit from "@/components/custom/student/StudentEdit";
import StudentProfile from "@/components/custom/student/StudentProfile";
import StudentRestore from "@/components/custom/student/StudentRestore";
import MonthlyAttendanceList from "@/components/custom/student/monthly_attendance/MonthlyAttendanceList";
import SubjectTeacherDetail from "@/components/subject_teacher/SubjectTeacherDetail";
import SubjectTeacherList from "@/components/custom/subject_teacher/SubjectTeacherList";
import SubjectTeacherCreate from '@/components/custom/subject_teacher/SubjectTeacherCreate';
import SubjectTeacherEdit from '@/components/custom/subject_teacher/SubjectTeacherEdit';
import SubjectTeacherImport from "@/components/custom/subject_teacher/SubjectTeacherImport";
import PaymentList from "@/components/custom/payment/PaymentList";
import PaymentCreate from "@/components/custom/payment/PaymentCreate";
import PaymentDetail from "@/components/custom/payment/PaymentDetail";
import PaymentEdit from "@/components/custom/payment/PaymentEdit";
import PaymentCheckout from "@/components/custom/payment/PaymentCheckout";
import PaymentRequestList from "@/components/custom/payment/PaymentRequestList";
import PaymentRequestDetail from "@/components/custom/payment/PaymentRequestDetail";
import PassPercentage from "@/components/report/PassPercentage";
import ClassScoreSummary from "@/components/custom/score_summary/ClassScoreSummary";
import TransactionReport from "@/components/report/TransactionReport";
import TransactionCreate from "@/components/custom/transaction/TransactionCreate";
import TransactionBatchCreate from "@/components/custom/transaction/TransactionBatchCreate";
import TransactionDetail from "@/components/custom/transaction/TransactionDetail";
import TransactionEdit from "@/components/custom/transaction/TransactionEdit";
import StudentStatementList from "@/components/custom/student_statement/StudentStatementList.vue";
import StudentStatementDetail from "@/components/custom/student_statement/StudentStatementDetail";
import StudentStatementImport from "@/components/custom/student_statement/StudentStatementImport.vue";
import PaymentMethodBalanceList from "@/components/custom/payment_method_balance/PaymentMethodBalanceList";
import DailyCashflow from "@/components/custom/cashflow/DailyCashflow";
import MonthlyCashflow from "@/components/custom/cashflow/MonthlyCashflow";
import YearlyCashflow from "@/components/custom/cashflow/YearlyCashflow";
import FinancialSummaryReport from "@/components/custom/cashflow/FinancialSummaryReport";
import GenerateFerryPayment from "@/components/custom/student_statement/GenerateFerryPayment";
import TuitionFeePaymentReport from "@/components/custom/report/TuitionFeePaymentReport";
import DiscountTypeList from "@/components/custom/discount_type/DiscountTypeList.vue";
import DiscountTypeCreate from "@/components/custom/discount_type/DiscountTypeCreate.vue";
import DiscountTypeEdit from "@/components/custom/discount_type/DiscountTypeEdit.vue";
import DiscountTypeDetail from "@/components/custom/discount_type/DiscountTypeDetail.vue";

import HolidayList from "@/components/custom/holiday/HolidayList";
import HolidayCreate from "@/components/custom/holiday/HolidayCreate";
import HolidayEdit from "@/components/custom/holiday/HolidayEdit";
import HolidayDetail from "@/components/custom/holiday/HolidayDetail";

import GradeList from "@/components/custom/grade/GradeList";
import GradeCreate from "@/components/custom/grade/GradeCreate";
import GradeEdit from "@/components/custom/grade/GradeEdit";

import PaymentMethodList from "@/components/custom/payment_method/PaymentMethodList";
import PaymentMethodCreate from "@/components/custom/payment_method/PaymentMethodCreate";
import PaymentMethodEdit from "@/components/custom/payment_method/PaymentMethodEdit";
import PaymentMethodDetail from "@/components/custom/payment_method/PaymentMethodDetail";

import TeacherTypeList from "@/components/custom/teacher_type/TeacherTypeList";
import TeacherTypeCreate from "@/components/teacher_type/TeacherTypeCreate";
import TeacherTypeEdit from "@/components/teacher_type/TeacherTypeEdit";
import TeacherTypeDetail from "@/components/teacher_type/TeacherTypeDetail";

import AppFormList from "@/components/custom/application_form/appFormList";
import AppFormCreate from "@/components/custom/application_form/AppFormCreate";
import AppFormItems from "@/components/custom/application_form/AppFormItems";
import AppFormDetail from "@/components/custom/application_form/AppFormDetail";
import AppFormEdit from "@/components/custom/application_form/AppFormEdit";
import AppFormEditItems from "@/components/custom/application_form/AppFormEditItems";
import InitialScreenPreview from "@/components/application_form/initialScreenPreview";

import SubjectList from "@/components/custom/subject/SubjectList";
import SubjectImport from "@/components/custom/subject/SubjectImport";
import SubjectCreate from "@/components/subject/SubjectCreate";
import SubjectEdit from "@/components/subject/SubjectEdit";
import SubjectDetail from "@/components/subject/SubjectDetail";

import AttendanceTeacherList from "@/components/custom/attendance_teacher/AttendanceTeacherList";
import AttendanceTeacherCreate from "@/components/custom/attendance_teacher/AttendanceTeacherCreate";
// import AttendanceTeacherDetail from "@/components/attendance_teacher/AttendanceTeacherDetail"; (Temporary Close Page)
// import AttendanceTeacherEdit from "@/components/attendance_teacher/AttendanceTeacherEdit"; (Temporary Close Page)
import TeacherLeaveList from "@/components/custom/teacher_leave/LeaveList";
import TeacherLeaveCreate from "@/components/custom/teacher_leave/LeaveCreate";
import TeacherLeaveEdit from "@/components/custom/teacher_leave/LeaveEdit";
import TeacherLeaveDetail from "@/components/teacher_leave/LeaveDetail";

import ChatRequestList from "@/components/custom/chat/RequestList";
import ChatMessageHistory from "@/components/chat/ChatHistory";

import ParentList from '@/components/custom/parent/ParentList';
import ParentCreate from '@/components/custom/parent/ParentCreate';
import ParentAndStudentCreate from '@/components/custom/parent/ParentAndStudentCreate';
import ParentEdit from '@/components/custom/parent/ParentEdit';
import ParentDetail from '@/components/custom/parent/ParentDetail';

import StudentPass from "@/components/custom/student/StudentPass";
import StudentFail from "@/components/custom/student/StudentFail";

import LeaveList from "@/components/custom/leave/LeaveList";
import LeaveCreate from "@/components/custom/leave/LeaveCreate";
import LeaveEdit from "@/components/leave/LeaveEdit";
import LeaveDetail from "@/components/leave/LeaveDetail";

import SalaryList from "@/components/custom/salary/SalaryList";
import SalaryCreate from "@/components/salary/SalaryCreate";
import SalaryEdit from "@/components/salary/SalaryEdit";
import SalaryDetail from "@/components/salary/SalaryDetail";

import DriverList from "@/components/custom/driver/DriverList";
import DriverCreate from "@/components/driver/DriverCreate";
import DriverEdit from "@/components/driver/DriverEdit";
import DriverDetail from "@/components/driver/DriverDetail";

import FerryCreate from "@/components/custom/ferry/FerryCreate";
import FerryList from "@/components/custom/ferry/FerryList";
import FerryEdit from "@/components/custom/ferry/FerryEdit";
import FerryDetail from "@/components/ferry/FerryDetail";

import RouteList from "@/components/custom/route/RouteList";
import RouteCreate from "@/components/route/RouteCreate";
import RouteEdit from "@/components/route/RouteEdit";
import RouteDetail from "@/components/custom/route/RouteDetail";

import FerryPickupList from "@/components/custom/ferry_pickup/FerryPickupList";
import FerryPickupDetail from "@/components/ferry_pickup/FerryPickupDetail";
import FerryPickupEdit from "@/components/ferry_pickup/FerryPickupEdit";
import FerryZoneList from "@/components/custom/ferry_zone/FerryZoneList.vue";
import FerryZoneGeneratePayment from "@/components/custom/ferry_zone/GenerateFerryPayment.vue";

import DailyFerryList from "@/components/custom/daily_ferry/DailyFerryList";
import DailyFerryCreate from "@/components/custom/daily_ferry/DailyFerryCreate";
import DailyFerryEdit from "@/components/custom/daily_ferry/DailyFerryEdit";
import DailyFerryDetail from "@/components/custom/daily_ferry/DailyFerryDetail";
import DailyFerryCopyForm from "@/components/custom/daily_ferry/DailyFerryCopyForm";

import CategoryItems from "@/components/custom/library/CategoryItems.vue";

import BookList from "@/components/custom/book_library/BookList";
import BookCreate from "@/components/book_library/BookCreate";
import BookDetail from "@/components/book_library/BookDetail";
import BookEdit from "@/components/book_library/BookEdit";

import LibraryMemberList from "@/components/custom/library_member/LibraryMemberList";
import LibraryMemberCreate from "@/components/library_member/LibraryMemberCreate";
import LibraryMemberDetail from "@/components/library_member/LibraryMemberDetail";
import LibraryMemberEdit from "@/components/library_member/LibraryMemberEdit";

import CheckoutCreate from "@/components/checkout/CheckoutCreate";
import CheckoutList from "@/components/custom/checkout/CheckoutList";
import CheckoutDetail from "@/components/checkout/CheckoutDetail";
import CheckoutEdit from "@/components/checkout/CheckoutEdit";

import DamageLossesCreate from "@/components/damage-losses/DamageLossesCreate";
import DamageLossesList from "@/components/custom/damage-losses/DamageLossesList";
import DamageLossesDetail from "@/components/damage-losses/DamageLossesDetail";
import DamageLossesEdit from "@/components/damage-losses/DamageLossesEdit";

import NoticeList from '@/components/custom/notice/NoticeList';
import NoticeCreate from '@/components/notice/NoticeCreate';
import NoticeDetail from '@/components/notice/NoticeDetail';
import NoticeEdit from '@/components/notice/NoticeEdit';

import Dashboard from "@/components/CustomHomeIndex";

import ScoreSettingList from "@/components/custom/score_setting/ScoreSettingList";
import ScoreSettingImport from "@/components/custom/score_setting/ScoreSettingImport";
import ScoreSettingCreate from "@/components/custom/score_setting/ScoreSettingCreate";
import ScoreSettingEdit from "@/components/custom/score_setting/ScoreSettingEdit";
import ScoreSettingDetail from "@/components/custom/score_setting/ScoreSettingDetail";

import CustomSettingPage from "@/components/custom/setting/CustomSettingPage";
import CustomSettingEdit from "@/components/custom/setting/CustomSettingEdit";

// tuition payment deatil & edit
import TuitionPaymentDetail from "@/components/custom/payment/TuitionPaymentDetail";
import TuitionPaymentEdit from "@/components/custom/payment/TuitionPaymentEdit";

import EarlyYearList from "@/components/custom/early-year/EarlyYearList";
import EarlyYearEdit from "@/components/custom/early-year/EarlyYearEdit";
import EarlyYearDetail from "@/components/custom/early-year/EarlyYearDetail";

import LeaveTypeList from "@/components/custom/leave_type/LeaveTypeList.vue";
import LeaveTypeCreate from "@/components/leave_type/LeaveTypeCreate.vue";
import LeaveTypeEdit from "@/components/leave_type/LeaveTypeEdit.vue";
import LeaveTypeDetail from "@/components/leave_type/LeaveTypeDetail.vue";

import ShiftSetting from "@/components/shift/ShiftSetting";
import ShiftAssign from "@/components/shift/ShiftAssign.vue";

import ShiftPatternList from "@/components/custom/shift_pattern/ShiftPatternList.vue";
import ShiftPatternCreate from "@/components/shift_pattern/ShiftPatternCreate.vue";
import ShiftPatternDetail from "@/components/shift_pattern/ShiftPatternDetail.vue";
import ShiftPatternEdit from "@/components/shift_pattern/ShiftPatternEdit.vue";

import TeacherMonthlyAttendanceHistory from "@/components/attendance_teacher/TeacherMonthlyAttendanceHistory.vue";

import PositionList from "@/components/custom/position/PositionList.vue";
import PositionCreate from "@/components/position/PositionCreate.vue";
import PositionEdit from "@/components/position/PositionEdit.vue";
import PositionDetail from "@/components/position/PositionDetail.vue";

import PaymentAttributeList from "@/components/custom/payment_attribute/PaymentAttributeList.vue";
import PaymentAttributeCreate from "@/components/payment_attribute/PaymentAttributeCreate.vue";
import PaymentAttributeEdit from "@/components/payment_attribute/PaymentAttributeEdit.vue";
import PaymentAttributeDetail from "@/components/payment_attribute/PaymentAttributeDetail.vue";

import PayslipList from "@/components/custom/payslip/PayslipList.vue";
import PayslipDetail from "@/components/payslip/PayslipDetail.vue";
import MyPayslipList from "@/components/payslip/MyPayslipList.vue";
import MyTimetable from "@/components/custom/timetable/MyTimetable.vue";

import SalaryChangesHistoryList from "@/components/salary_changes_history/SalaryChangesHistoryList";

import LeaveBalanceList from "@/components/custom/leave_balance/LeaveBalanceList.vue";
import LeaveBalanceEdit from "@/components/leave_balance/LeaveBalanceEdit.vue";

import SkillList from "@/components/custom/skill/SkillList.vue";
import SkillCreate from "@/components/skill/SkillCreate.vue";
import SkillEdit from "@/components/skill/SkillEdit.vue";

import PaymentAttributeDetailList from "@/components/custom/payment_att_detail/PaymentAttributeDetailList.vue";
import PaymentAttributeDetailCreate from "@/components/payment_att_detail/PaymentAttributeDetailCreate.vue";
import PaymentAttributeDetailEdit from "@/components/payment_att_detail/PaymentAttributeDetailEdit.vue";

import ReferralManagementList from "@/components/custom/referral/ReferralManagementList";

import RefundConfirmation from "@/components/custom/refund/RefundConfirmation.vue";
import RefundHistoryList from "@/components/custom/refund/RefundHistoryList.vue";
import RefundHistoryDetail from "@/components/custom/refund/RefundHistoryDetail.vue";

import IncomeExpenseReport from "@/components/custom/report/IncomeExpenseReport.vue";
import EmployeeList from "@/components/employee/EmployeeList";
import EmployeeCreate from "@/components/employee/EmployeeCreate";
import EmployeeEdit from "@/components/employee/EmployeeEdit";
import EmployeeProfile from "@/components/employee/EmployeeProfile";

Vue.use(VueRouter);

['push', 'replace'].forEach(method => {
  const original = VueRouter.prototype[method];
  VueRouter.prototype[method] = function (location, onResolve, onReject) {
    if (this.currentRoute.fullPath === this.resolve(location).route.fullPath) {
      return Promise.resolve(this.currentRoute);
    }
    const result = original.call(this, location, onResolve, onReject);
    if (result && typeof result.catch === 'function') {
      return result.catch(err => {
        if (
          ['NavigationDuplicated', 'NavigationCancelled'].includes(err.name) ||
          (typeof err.message === 'string' && err.message.includes('Navigation cancelled'))
        ) {
          return;
        }
        throw err;
      });
    }
    return result;
  };
});

const routes = [
  {
    path: "/exam/list",
    name: "examList",
    component: ExamList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "newTeacher"] },
  },
  {
    path: "/exam/create",
    name: "examCreate",
    component: ExamCreate,
    meta: { restricted: ["libraryAdmin", "classMonitor", "officeAdmin", "accountant", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/exam/import",
    name: "examImport",
    component: ExamImport,
    meta: { restricted: ["libraryAdmin", "classMonitor", "officeAdmin", "accountant", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/exam/detail/:exam_id",
    name: "examDetail",
    component: ExamDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor", "newTeacher"] },
  },
  {
    path: "/exam/edit/:exam_id",
    name: "examEdit",
    component: ExamEdit,
    meta: { restricted: ["libraryAdmin", "classMonitor", "accountant", "officeAdmin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/grading/list",
    name: "gradingList",
    component: GradingList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "newTeacher"] },
  },
  {
    path: "/students/class-score-summary",
    name: "ClassScoreSummary",
    component: ClassScoreSummary,
    meta: { restricted: ["libraryAdmin", "classMonitor", "newTeacher"] },
  },
  {
    path: "/grading/create",
    name: "gradingCreate",
    component: GradingCreate,
    meta: { restricted: ["libraryAdmin", "classMonitor", "officeAdmin", "accountant", "newTeacher"] },
  },
  {
    path: "/grading/import",
    name: "gradingImport",
    component: GradingImport,
    meta: { restricted: ["libraryAdmin", 'classMonitor', "officeAdmin", "accountant", "newTeacher"] },
  },
  {
    path: "/grading/detail/:student_id/:exam_id",
    name: "gradingDetail",
    component: GradingDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor", "newTeacher"] },
  },
  {
    path: "/grading/edit/:student_id/:exam_id",
    name: "gradingEdit",
    component: GradingEdit,
    meta: { restricted: ["libraryAdmin", "classMonitor", "officeAdmin", "accountant", "newTeacher"] },
  },
  {
    path: "/student/list",
    name: "studentList",
    component: StudentList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "newTeacher"] },
  },
  {
    path: "/student/edit/:id",
    name: "studentEdit",
    component: StudentEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/student/profile/:leavedStatus/:id",
    name: "studentProfile",
    component: StudentProfile,
    meta: { restricted: ["libraryAdmin", "classMonitor", "newTeacher"] },
  },
  {
    path: "/student/create/:parentId",
    name: "studentCreate",
    component: StudentCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/student/pass/:id",
    name: "studentPass",
    component: StudentPass,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "academicCoordinator", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/student/fail/:id",
    name: "studentFail",
    component: StudentFail,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "academicCoordinator", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/student/restore/:id",
    name: "studentRestore",
    component: StudentRestore,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/monthly/attendance/list",
    name: "monthlyAttendance",
    component: MonthlyAttendanceList,
    meta: { restricted: ["libraryAdmin", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/subjectTeacher/list",
    name: "subjectTeacherList",
    component: SubjectTeacherList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/subjectTeacher/import",
    name: "subjectTeacherImport",
    component: SubjectTeacherImport,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "officeAdmin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/subjectTeacher/detail/:id",
    name: "subjectTeacherDetail",
    component: SubjectTeacherDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },

  {
    path: "/subjectTeacher/create",
    name: "subjectTeacherCreate",
    component: SubjectTeacherCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "officeAdmin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/subjectTeacher/edit/:id",
    name: "subjectTeacherEdit",
    component: SubjectTeacherEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "officeAdmin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/course/list",
    name: "courseList",
    component: CourseList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "newTeacher"] },
  },
  {
    path: "/course/edit/:id",
    name: "courseEdit",
    component: CourseEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "officeAdmin", "newTeacher"] },
  },
  {
    path: "/course/detail/:id",
    name: "courseDetail",
    component: CourseDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor", "newTeacher"] },
  },
  {
    path: "/course/create",
    name: "courseCreate",
    component: CourseCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "officeAdmin", "newTeacher"] },
  },
  {
    path: "/course/import",
    name: "courseImport",
    component: CourseImport,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "officeAdmin", "homeRoomTeacher", "assistantTeacher", "newTeacher"] },
  },
  {
    path: "/attendanceStudent/list",
    name: "attendanceStudentList",
    component: AttendanceStudentList,
    meta: { restricted: ["libraryAdmin", "newTeacher"] },
  },

  {
    path: "/attendanceStudent/create",
    name: "attendanceStudentCreate",
    component: AttendanceStudentCreate,
    meta: { restricted: ["libraryAdmin", "officeAdmin", "accountant", "principal", "academicCoordinator", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/attendanceStudent/detail/:id",
    name: "attendanceStudentDetail",
    component: AttendanceStudentDetail,
    meta: { restricted: ["libraryAdmin", "newTeacher"] },
  },
  {
    path: "/attendanceStudent/edit/:id",
    name: "attendanceStudentEdit",
    component: AttendanceStudentEdit,
    meta: { restricted: ["libraryAdmin", "officeAdmin", "accountant", "principal", "academicCoordinator", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/attendance-rate/list",
    name: "attendanceRateList",
    component: AttendanceRateList,
    meta: { restricted: ["libraryAdmin", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/assignment/list",
    name: "assignmentList",
    component: AssignmentList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "newTeacher"] },
  },
  {
    path: "/assignment/edit/:id",
    name: "assignmentEdit",
    component: AssignmentEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "officeAdmin", "newTeacher"] }
  },
  {
    path: "/assignment/detail/:id",
    name: "assignmentDetail",
    component: AssignmentDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor", "newTeacher"] },
  },
  {
    path: "/item/list",
    name: "itemList",
    component: ItemList,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/item/create",
    name: "itemCreate",
    component: ItemCreate,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "principal", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/item/detail/:id",
    name: "itemDetail",
    component: ItemDetail,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },

  {
    path: "/item/edit/:id",
    name: "itemEdit",
    component: ItemEdit,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "principal", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/item/import",
    name: "itemImport",
    component: ItemImport,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "principal", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/period/list",
    name: "periodList",
    component: PeriodList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/period/create",
    name: "periodCreate",
    component: PeriodCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "principal", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/period/edit/:id",
    name: "periodEdit",
    component: PeriodEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "principal", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/period/detail/:id",
    name: "periodDetail",
    component: PeriodDetail,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "principal", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/period/:acdYearId/term/create",
    name: "termCreate",
    component: TermCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "principal", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/period/:acdYearId/term/edit/:id",
    name: "termEdit",
    component: TermEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "principal", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/campusGrade/create",
    name: "campusGradeCreate",
    component: CampusGradeCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "officeAdmin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/campusGrade/edit/:id",
    name: "campusGradeEdit",
    component: CampusGradeEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "officeAdmin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/campusGrade/list",
    name: "campusGradeList",
    component: CampusGradeList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/campusGrade/import",
    name: "campusGradeImport",
    component: CampusGradeImport,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "officeAdmin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/gradeFee/create",
    name: "gradeFeeCreate",
    component: GradeFeeCreate,
    meta: { restricted: ["libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/gradeFee/edit/:id",
    name: "gradeFeeEdit",
    component: GradeFeeEdit,
    meta: { restricted: ["libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/gradeFee/import",
    name: "gradeFeeImport",
    component: GradeFeeImport,
    meta: { restricted: ["libraryAdmin", "classMonitor", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/gradeFee/detail/:id",
    name: "gradeFeeDetail",
    component: GradeFeeDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/gradeFee/list",
    name: "gradeFeeList",
    component: GradeFeeList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/class/list",
    name: "classList",
    component: ClassList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/class/import",
    name: "classImport",
    component: ClassImport,
    meta: { restricted: ["libraryAdmin", "classMonitor", "accountant", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/class/create",
    name: "classCreate",
    component: ClassCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/class/edit/:id",
    name: "classEdit",
    component: ClassEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/class/detail/:id",
    name: "classDetail",
    component: ClassDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/transaction/list",
    name: "transactionList",
    component: TransactionList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/transactionCategory/list",
    name: "transactionCategoryList",
    component: TransactionCategoryList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "officeAdmin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/transactionCategory/create",
    name: "transactionCategoryCreate",
    component: TransactionCategoryCreate,
    meta: { restricted: ["libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/transactionCategory/detail/:id",
    name: "transactionCategoryDetail",
    component: TransactionCategoryDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor", "officeAdmin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/transactionCategory/edit/:id",
    name: "transactionCategoryEdit",
    component: TransactionCategoryEdit,
    meta: { restricted: ["libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/timetable/import",
    name: "timetableImport",
    component: TimetableImport,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "officeAdmin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/payment-method-balance/list",
    name: "paymentMethodBalanceList",
    component: PaymentMethodBalanceList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/report/daily-cashflow",
    name: "dailyCashflow",
    component: DailyCashflow,
    meta: { restricted: ["libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/report/monthly-cashflow",
    name: "monthlyCashflow",
    component: MonthlyCashflow,
    meta: { restricted: ["libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/report/yearly-cash-flow",
    name: "yearlyCashflow",
    component: YearlyCashflow,
    meta: { restricted: ["libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/report/financial-summary",
    name: "financialSummaryReport",
    component: FinancialSummaryReport,
    meta: { restricted: ["libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/timetable/list",
    name: "timetableList",
    component: TimetableList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "newTeacher"] },
  },
  {
    path: "/timetable/create",
    name: "timetableCreate",
    component: TimetableCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "officeAdmin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/timetable/detail/:id",
    name: "timetableDetail",
    component: TimetableDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor", "newTeacher"] },
  },
  {
    path: "/timetable/edit/:id",
    name: "timetableEdit",
    component: TimetableEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "officeAdmin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/timetableTemplate/list",
    name: "timetableTemplateList",
    component: TimetableTemplateList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/timetableTemplate/create",
    name: "timetableTemplateCreate",
    component: TimetableTemplateCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "officeAdmin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/timetableTemplate/detail/:id",
    name: "timetableTemplateDetail",
    component: TimetableTemplateDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/timetableTemplate/edit/:id",
    name: "timetableTemplateEdit",
    component: TimetableTemplateEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "officeAdmin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/applicant/list",
    name: "applicantList",
    component: ApplicantList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/assignment/create",
    name: "assignmentCreate",
    component: AssignmentCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "officeAdmin", "newTeacher"] }
  },
  {
    path: "/payment/list",
    name: "paymentList",
    component: PaymentList,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/payment/create",
    name: "paymentCreate",
    component: PaymentCreate,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/payment/detail/:invoiceId",
    name: "paymentDetail",
    component: PaymentDetail,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/payment/edit/:invoiceId",
    name: "paymentEdit",
    component: PaymentEdit,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/payment/checkout",
    name: "paymentCheckout",
    component: PaymentCheckout,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "principal", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/checkout/list",
    name: "checkoutList",
    component: CheckoutList,
    meta: { restricted:[ "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/checkout/create",
    name: "checkoutCreate",
    component: CheckoutCreate,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "principal", "academicCoordinator", "accountant", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/checkout/detail/:id",
    name: "checkoutDetail",
    component: CheckoutDetail,
    meta: { restricted: ["classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/checkout/edit/:id",
    name: "checkoutEdit",
    component: CheckoutEdit,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "principal", "academicCoordinator", "accountant", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/payment_request/list",
    name: "paymentRequestList",
    component: PaymentRequestList,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/payment_request/detail/:invoiceId",
    name: "paymentRequestDetail",
    component: PaymentRequestDetail,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "newTeacher"] }
  },
  {
    path: "/report/pass-percentage",
    name: "PassPercentage",
    component: PassPercentage,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "newTeacher"] },
  },
  {
    path: "/report/transaction",
    name: "transactionReport",
    component: TransactionReport,
    meta: { restricted: ["libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/report/income-expense",
    name: "incomeExpenseReport",
    component: IncomeExpenseReport,
    meta: { restricted: ["libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/transaction/create",
    name: "transactionCreate",
    component: TransactionCreate,
    meta: { restricted: ["libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "principal", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/transaction/batch-create",
    name: "transactionBatchCreate",
    component: TransactionBatchCreate,
    meta: { restricted: ["libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "principal", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/transaction/detail/:id",
    name: "transactionDetail",
    component: TransactionDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/transaction/edit/:id",
    name: "transactionEdit",
    component: TransactionEdit,
    meta: { restricted: ["libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "principal", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/student/enrollment/create/:classStudentId",
    name: "enrollmentPaymentCreate",
    component: EnrollmentPaymentCreate,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/student/enrollment/invoice/create/:classStudentId/:tuitionPaymentId",
    name: "enrollmentInvoiceCreate",
    component: EnrollmentInvoiceCreate,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/student/enrollment/edit/:tuitionPaymentId/:classStudentId",
    name: "enrollmentPaymentEdit",
    component: EnrollmentPaymentEdit,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/student/enrollment/invoice/edit/:classStudentId/:tuitionPaymentId",
    name: "enrollmentInvoiceEdit",
    component: EnrollmentInvoiceEdit,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/student/statement/list",
    name: "studentStatementList",
    component: StudentStatementList,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/student/statement/import",
    name: "studentStatementImport",
    component: StudentStatementImport,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/student/statement/detail/:tuitionPaymentId",
    name: "studentStatementDetail",
    component: StudentStatementDetail,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/student/statement/generate-ferry-payment/:tuitionPaymentId/:classStudentId",
    name: "generateFerryPayment",
    component: GenerateFerryPayment,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/report/tuitionFee",
    name: "TuitionFeePaymentReport",
    component: TuitionFeePaymentReport,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/discountType/list",
    name: "discountTypeList",
    component: DiscountTypeList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/discountType/create",
    name: "discountTypeCreate",
    component: DiscountTypeCreate,
    meta: { restricted: ["libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "principal", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/discountType/detail/:id",
    name: "discountTypeDetail",
    component: DiscountTypeDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/discountType/edit/:id",
    name: "discountTypeEdit",
    component: DiscountTypeEdit,
    meta: { restricted: ["libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "principal", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/holiday/list",
    name: "holidayList",
    component: HolidayList,
    meta: { restricted: ["libraryAdmin", "classMonitor"] }
  },
  {
    path: "/holiday/create",
    name: "holidayCreate",
    component: HolidayCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "principal", "academicCoordinator", "officeAdmin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/holiday/edit/:id",
    name: "holidayEdit",
    component: HolidayEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "principal", "academicCoordinator", "officeAdmin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },

  {
    path: "/holiday/detail/:id",
    name: "holidayDetail",
    component: HolidayDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher"] }
  },
  {
    path: "/grade/list",
    name: "gradeList",
    component: GradeList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/grade/create",
    name: "gradeCreate",
    component: GradeCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/grade/edit/:id",
    name: "gradeEdit",
    component: GradeEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/paymentMethod/list",
    name: "paymentMethodList",
    component: PaymentMethodList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/paymentMethod/create",
    name: "paymentMethodCreate",
    component: PaymentMethodCreate,
    meta: { restricted: ["libraryAdmin", "classMonitor", "officeAdmin", "principal", "academicCoordinator", "homeRoomTeacher", "newTeacher"] }
  },
  {
    path: "/paymentMethod/edit/:id",
    name: "paymentMethodEdit",
    component: PaymentMethodEdit,
    meta: { restricted: ["libraryAdmin", "classMonitor", "officeAdmin", "principal", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/paymentMethod/detail/:id",
    name: "paymentMethodDetail",
    component: PaymentMethodDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/teacherType/list",
    name: "teacherTypeList",
    component: TeacherTypeList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/teacherType/create",
    name: "teacherTypeCreate",
    component: TeacherTypeCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "officeAdmin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/teacherType/edit/:id",
    name: "teacherTypeEdit",
    component: TeacherTypeEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "officeAdmin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/teacherType/detail/:id",
    name: "teacherTypeDetail",
    component: TeacherTypeDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/applicationForm/list",
    name: "appFormList",
    component: AppFormList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/applicationForm/create",
    name: "appFormCreate",
    component: AppFormCreate,
    meta: { restricted: ["accountant", "classMonitor", "libraryAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/applicationForm/items",
    name: "appFormItems",
    component: AppFormItems,
    meta: { restricted: ["accountant", "classMonitor", "libraryAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/applicationForm/detail/:id",
    name: "appFormDetail",
    component: AppFormDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/applicationForm/edit/:id",
    name: "appFormEdit",
    component: AppFormEdit,
    meta: { restricted: ["accountant", "classMonitor", "libraryAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/applicationForm/edit/:id/items",
    name: "appFormEditItems",
    component: AppFormEditItems,
    meta: { restricted: ["accountant", "classMonitor", "libraryAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/applicationForm/preview",
    name: "initialScreenPreview",
    component: InitialScreenPreview,
    meta: { restricted: ["accountant", "classMonitor", "libraryAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/applicant/detail/:id",
    name: "applicantDetail",
    component: ApplicantDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/subject/list",
    name: "subjectList",
    component: SubjectList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/subject/import",
    name: "subjectImport",
    component: SubjectImport,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "officeAdmin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/subject/create",
    name: "subjectCreate",
    component: SubjectCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "officeAdmin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/subject/edit/:campusGradeId",
    name: "subjectEdit",
    component: SubjectEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "officeAdmin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/subject/detail/:campusGradeId",
    name: "subjectDetail",
    component: SubjectDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/employee-attendance/list",
    name: "attendanceTeacherList",
    component: AttendanceTeacherList,
    meta: { restricted: ["libraryAdmin", "classMonitor"] }
  },
  {
    path: "/employee-attendance/register",
    name: "attendanceTeacherCreate",
    component: AttendanceTeacherCreate,
    meta: { restricted: ["libraryAdmin", "classMonitor"] }
  },
  // { (Temporary Close Pages)
  //   path: "/attendanceTeacher/detail/:teacher_id/:date",
  //   name: "attendanceTeacherDetail",
  //   component: AttendanceTeacherDetail,
  //   meta: { restricted: ["libraryAdmin", "classMonitor"] }
  // },
  // {
  //   path: "/attendanceTeacher/edit/:teacher_id/:date",
  //   name: "attendanceTeacherEdit",
  //   component: AttendanceTeacherEdit,
  //   meta: { restricted: ["libraryAdmin", "classMonitor", "academicCoordinator"] }
  // },
  {
    path: "/employee/leave/list",
    name: "teacherLeaveList",
    component: TeacherLeaveList,
  },
  {
    path: "/teacher/dashboard",
    name: "teacherDashboard",
    component: Dashboard,
    meta: { restricted: ["libraryAdmin", "classMonitor", "academicCoordinator", "staff", "officeAdmin", "principal", "admin"] }
  },
  {
    path: "/employee/leave/create",
    name: "teacherLeaveCreate",
    component: TeacherLeaveCreate,
  },
  {
    path: "/employee/leave/edit/:id",
    name: "teacherLeaveEdit",
    component: TeacherLeaveEdit,
  },
  {
    path: "/employee/leave/detail/:id",
    name: "teacherLeaveDetail",
    component: TeacherLeaveDetail,
  },
  {
    path: "/chat/request/list",
    name: "chatRequestList",
    component: ChatRequestList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "newTeacher"] }
  },
  {
    path: "/chat/message/history",
    name: "ChatMessageHistory",
    component: ChatMessageHistory,
    meta: { restricted: ["libraryAdmin", "classMonitor", "newTeacher"] }
  },
  {
    path: "/parent/list",
    name: "parentList",
    component: ParentList,
    meta: { restricted: ["libraryAdmin", "classMonitor"] }
  },
  {
    path: "/parent/create",
    name: "parentCreate",
    component: ParentCreate,
    meta: { restricted: ["libraryAdmin", "classMonitor", "academicCoordinator", "accountant", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/parent-student/create",
    name: "parentAndStudentCreate",
    component: ParentAndStudentCreate,
    meta: { restricted: ["libraryAdmin", "classMonitor", "academicCoordinator", "accountant", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/parent/edit/:id",
    name: "parentEdit",
    component: ParentEdit,
    meta: { restricted: ["libraryAdmin", "classMonitor", "academicCoordinator", "accountant", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/parent/detail/:id",
    name: "parentDetail",
    component: ParentDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor", "newTeacher"] }
  },
  {
    path: "/leave/list",
    name: "leaveList",
    component: LeaveList,
    meta: { restricted: ["libraryAdmin", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/leave/create",
    name: "leaveCreate",
    component: LeaveCreate,
    meta: { restricted: ["libraryAdmin", "classMonitor", "accountant", "academicCoordinator", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/leave/edit/:id",
    name: "leaveEdit",
    component: LeaveEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "academicCoordinator", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/leave/detail/:id",
    name: "leaveDetail",
    component: LeaveDetail,
    meta: { restricted: ["libraryAdmin", "newTeacher"] }
  },

  {
    path: "/salary/list",
    name: "salaryList",
    component: SalaryList,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/salary/create",
    name: "salaryCreate",
    component: SalaryCreate,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "principal", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/salary/edit/:id",
    name: "salaryEdit",
    component: SalaryEdit,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "principal", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/salary/detail/:id",
    name: "salaryDetail",
    component: SalaryDetail,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/driver/list",
    name: "driverList",
    component: DriverList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/driver/create",
    name: "driverCreate",
    component: DriverCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/driver/edit/:id",
    name: "driverEdit",
    component: DriverEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/driver/detail/:id",
    name: "driverDetail",
    component: DriverDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/ferry/create",
    name: "ferryCreate",
    component: FerryCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "principal", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/ferry/list",
    name: "ferryList",
    component: FerryList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/ferry/edit/:id",
    name: "ferryEdit",
    component: FerryEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "principal", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/ferry/detail/:id",
    name: "ferryDetail",
    component: FerryDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/route/list",
    name: "routeList",
    component: RouteList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/route/create",
    name: "routeCreate",
    component: RouteCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "principal", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/route/edit/:id",
    name: "routeEdit",
    component: RouteEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "principal", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/route/detail/:id",
    name: "routeDetail",
    component: RouteDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/ferryPickup/list",
    name: "ferryPickupList",
    component: FerryPickupList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/ferryPickup/detail/:status/:id",
    name: "ferryPickupDetail",
    component: FerryPickupDetail,
    props: true,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/ferryPickup/edit/:status/:id",
    name: "ferryPickupEdit",
    component: FerryPickupEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "principal", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/dailyFerry/list",
    name: "dailyFerryList",
    component: DailyFerryList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/dailyFerry/create",
    name: "dailyFerryCreate",
    component: DailyFerryCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "principal", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/dailyFerry/edit/:id",
    name: "dailyFerryEdit",
    component: DailyFerryEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "principal", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/dailyFerry/detail/:id",
    name: "dailyFerryDetail",
    component: DailyFerryDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/dailyFerry/duplicate/:id",
    name: "dailyFerryCopyForm",
    component: DailyFerryCopyForm,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/ferryZone/list",
    name: "ferryZoneList",
    component: FerryZoneList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/ferryZone/generate-payment",
    name: "ferryZoneGeneratePayment",
    component: FerryZoneGeneratePayment,
    meta: { restricted: ["libraryAdmin", "classMonitor", "academicCoordinator"] }
  },
  {
    path: "/library/category",
    name: "categoryItems",
    component: CategoryItems,
    meta: { restricted: ["classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/book_library/list",
    name: "bookList",
    component: BookList,
    meta: { restricted: ["classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/book_library/create",
    name: "bookCreate",
    component: BookCreate,
    meta: { restricted: ["accountant", "classMonitor", "principal", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/book_library/detail/:id",
    name: "bookDetail",
    component: BookDetail,
    meta: { restricted: ["classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/book_library/edit/:id",
    name: "bookEdit",
    component: BookEdit,
    meta: { restricted: ["accountant", "classMonitor", "principal", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/libraryMember/list",
    name: "libraryMemberList",
    component: LibraryMemberList,
    meta: { restricted: ["classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/libraryMember/create",
    name: "libraryMemberCreate",
    component: LibraryMemberCreate,
    meta: { restricted: ["accountant", "classMonitor", "principal", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/libraryMember/detail/:id",
    name: "libraryMemberDetail",
    component: LibraryMemberDetail,
    meta: { restricted: ["classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/libraryMember/edit/:id",
    name: "libraryMemberEdit",
    component: LibraryMemberEdit,
    meta: { restricted: ["accountant", "classMonitor", "principal", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/damagelosses/list",
    name: "damageLossesList",
    component: DamageLossesList,
    meta: { restricted: ["classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/damagelosses/create",
    name: "damageLossesCreate",
    component: DamageLossesCreate,
    meta: { restricted: ["accountant", "classMonitor", "principal", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/damagelosses/detail/:id",
    name: "damageLossesDetail",
    component: DamageLossesDetail,
    meta: { restricted: ["classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/damagelosses/edit/:id",
    name: "damageLossesEdit",
    component: DamageLossesEdit,
    meta: { restricted: ["accountant", "classMonitor", "principal", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/notice/list",
    name: "noticeList",
    component: NoticeList,
    meta: { restricted: ["libraryAdmin", "classMonitor"] }
  },
  {
    path: "/notice/create",
    name: "noticeCreate",
    component: NoticeCreate,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/notice/detail/:id",
    name: "noticeDetail",
    component: NoticeDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor"] }
  },
  {
    path: "/notice/edit/:id",
    name: "noticeEdit",
    component: NoticeEdit,
    meta: { restricted: ["accountant", "libraryAdmin", "classMonitor", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/",
    name: "dashboard",
    component: Dashboard,
    meta: { restricted: ["libraryAdmin", "classMonitor", "campusAdmin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/score-setting",
    name: "scoreSettingList",
    component: ScoreSettingList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/score-setting/import",
    name: "scoreSettingImport",
    component: ScoreSettingImport,
    meta: { restricted: ["libraryAdmin", "classMonitor", "accountant", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/score-setting/create",
    name: "scoreSettingCreate",
    component: ScoreSettingCreate,
    meta: { restricted: ["libraryAdmin", "classMonitor", "accountant", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/score-setting/:id/edit",
    name: "scoreSettingEdit",
    component: ScoreSettingEdit,
    meta: { restricted: ["libraryAdmin", "classMonitor", "accountant", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/score-setting/:id/info",
    name: "scoreSettingDetail",
    component: ScoreSettingDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/custom/setting",
    name: "customSettingPage",
    component: CustomSettingPage,
    meta: { restricted: ["staff", "accountant", "libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/custom/setting/edit",
    name: "customSettingEdit",
    component: CustomSettingEdit,
    meta: { restricted: ["staff", "accountant", "libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/report-card-grading",
    name: "reportCardGradingList",
    component: ReportCardGradingList,
    meta: { restricted: ["libraryAdmin", "newTeacher"] }
  },
  {
    path: "/report-card-grading/import",
    name: "reportCardGradingImport",
    component: ReportCardGradingImport,
    meta: { restricted: ["libraryAdmin", "classMonitor", "accountant", "officeAdmin", "newTeacher"] }
  },
  {
    path: "/report-card-grading/:id/info",
    name: "reportCardGradingDetail",
    component: ReportCardGradingDetail,
    meta: { restricted: ["libraryAdmin", "newTeacher"] }
  },
  {
    path: "/report-card-grading/:id/edit",
    name: "reportCardGradingEdit",
    component: ReportCardGradingEdit,
    meta: { restricted: ["libraryAdmin", "classMonitor", "accountant", "officeAdmin", "newTeacher"] }
  },
  {
    path: "/student/statement/detail/:tuitionPaymentId/tuition-payment/:studentPaymentId",
    name: "tuitionPaymentDetail",
    component: TuitionPaymentDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/student/statement/detail/:tuitionPaymentId/tuition-payment/:studentPaymentId/edit",
    name: "tuitionPaymentEdit",
    component: TuitionPaymentEdit,
    meta: { restricted: ["libraryAdmin", "classMonitor", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/early-year/list",
    name: "earlyYearList",
    component: EarlyYearList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/early-year/edit/:academicYearId/:id",
    name: "earlyYearEdit",
    component: EarlyYearEdit,
    meta: { restricted: ["libraryAdmin", "classMonitor", "officeAdmin", "accountant", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/early-year/detail/:academicYearId/:id",
    name: "earlyYearDetail",
    component: EarlyYearDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/leaveType/list",
    name: "leaveTypeList",
    component: LeaveTypeList,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/leaveType/create",
    name: "leaveTypeCreate",
    component: LeaveTypeCreate,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/leaveType/edit/:id",
    name: "leaveTypeEdit",
    component: LeaveTypeEdit,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/leaveType/detail/:id",
    name: "leaveTypeDetail",
    component: LeaveTypeDetail,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/shift/setting",
    name: "shiftSetting",
    component: ShiftSetting,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/shift/assign",
    name: "ShiftAssign",
    component: ShiftAssign,
    meta: { restricted: ["admin", "staff", "libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/shift-pattern",
    name: "shiftPatternList",
    component: ShiftPatternList,
    meta: { restricted: ["libraryAdmin", "staff", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/shift-pattern/create",
    name: "shiftPatternCreate",
    component: ShiftPatternCreate,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/shift-pattern/:id",
    name: "shiftPatternDetail",
    component: ShiftPatternDetail,
    meta: { restricted: ["libraryAdmin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/shift-pattern/edit/:id",
    name: "shiftPatternEdit",
    component: ShiftPatternEdit,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/teacher/monthly/attendance/history",
    name: "teacherMonthlyAttendance",
    component: TeacherMonthlyAttendanceHistory,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor"] },
  },
  {
    path: "/position/list",
    name: "positionList",
    component: PositionList,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/position/create",
    name: "positionCreate",
    component: PositionCreate,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/position/detail/:id",
    name: "positionDetail",
    component: PositionDetail,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/position/edit/:id",
    name: "positionEdit",
    component: PositionEdit,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/paymentAttribute/list",
    name: "paymentAttributeList",
    component: PaymentAttributeList,
    meta: { restricted: ["staff", "libraryAdmin", "admin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/paymentAttribute/create",
    name: "paymentAttributeCreate",
    component: PaymentAttributeCreate,
    meta: { restricted: ["staff", "libraryAdmin", "admin", "classMonitor", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/paymentAttribute/detail/:id",
    name: "paymentAttributeDetail",
    component: PaymentAttributeDetail,
    meta: { restricted: ["staff", "libraryAdmin", "admin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/paymentAttribute/edit/:id",
    name: "paymentAttributeEdit",
    component: PaymentAttributeEdit,
    meta: { restricted: ["staff", "libraryAdmin", "admin", "classMonitor", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/payslip/list",
    name: "payslipList",
    component: PayslipList,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/my/timetable",
    name: "myTimetable",
    component: MyTimetable,
    meta: { restricted: ["libraryAdmin", "classMonitor", "admin", "academicCoordinator", "staff", "officeAdmin", "principal", "admin"] },
  },
  {
    path: "/my/payslips",
    name: "myPayslipList",
    component: MyPayslipList
  },
  {
    path: "/my/payslips/:empPaymentId/detail",
    name: "myPayslipDetail",
    component: PayslipDetail,
    meta: {
      backRoute: "myPayslipList",
      breadcrumbLabel: "My Payslip Records",
      title: "My Payslip Detail"
    }
  },
  {
    path: "/payslip/:empPaymentId/detail",
    name: "payslipDetail",
    component: PayslipDetail,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/salary-changes-history/list",
    name: "SalaryChangesHistoryList",
    component: SalaryChangesHistoryList,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/leaveBalance/list",
    name: "leaveBalanceList",
    component: LeaveBalanceList,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "admin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/leaveBalance/edit/:employeeId",
    name: "leaveBalanceEdit",
    component: LeaveBalanceEdit,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "admin", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/skill",
    name: "skillList",
    component: SkillList,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "admin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/skill/create",
    name: "skillCreate",
    component: SkillCreate,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "admin", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/skill/edit/:employeeableId/:type",
    name: "skillEdit",
    component: SkillEdit,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "admin", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/paymentAttributeDetail/list",
    name: "paymentAttributeDetailList",
    component: PaymentAttributeDetailList,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "admin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/paymentAttributeDetail/create",
    name: "paymentAttributeDetailCreate",
    component: PaymentAttributeDetailCreate,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "admin", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/paymentAttributeDetail/edit/:employeeId",
    name: "paymentAttributeDetailEdit",
    component: PaymentAttributeDetailEdit,
    meta: { restricted: ["staff", "libraryAdmin", "classMonitor", "admin", "officeAdmin", "academicCoordinator", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] },
  },
  {
    path: "/referral/list",
    name: "referralManagementList",
    component: ReferralManagementList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/tuition-refund-confirm/:tuitionPaymentId",
    name: 'tuitionPaymentRefundConfirm',
    component: RefundConfirmation,
    meta: { restricted: ["libraryAdmin", "classMonitor", "academicCoordinator", "officeAdmin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/refund/history/list",
    name: 'refundHistoryList',
    component: RefundHistoryList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "academicCoordinator", "officeAdmin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/refund/history/detail/:id",
    name: 'refundHistoryDetail',
    component: RefundHistoryDetail,
    meta: { restricted: ["libraryAdmin", "classMonitor", "academicCoordinator", "officeAdmin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/employee/list",
    name: "employeeList",
    component: EmployeeList,
    meta: { restricted: ["libraryAdmin", "classMonitor", "admin", "academicCoordinator", "officeAdmin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },
  {
    path: "/employee/create",
    name: "employeeCreate",
    component: EmployeeCreate,
    meta: { restricted: ["libraryAdmin", "classMonitor", "admin", "academicCoordinator", "officeAdmin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },

  {
    path: "/employee/edit/:id",
    name: "employeeEdit",
    component: EmployeeEdit,
    meta: { restricted: ["libraryAdmin", "classMonitor", "admin", "academicCoordinator", "officeAdmin", "homeRoomTeacher", "assistantTeacher", "subjectTeacher", "newTeacher"] }
  },

  {
    path: "/employee/profile/:id",
    name: "employeeProfile",
    component: EmployeeProfile,
  },
];

export const customGuard = (to, from, next) => {
  const user = store.state.user;
  const restricted = to.meta.restricted;
  const restrictedRoles = Array.isArray(restricted) ? restricted : [restricted];

  if (!user || restrictedRoles.length <= 0) return next();
  
  if (user.loginType === 'admin') {
    const role = user.roleLabel;

    if (role && restrictedRoles.includes(role)) {
      const redirects = {
        libraryAdmin: "categoryItems",
        classMonitor: "attendanceStudentList",
        campusAdmin: "employeeList",
      };

      return next({
        name: redirects[role] || "dashboard",
      });
    }

    return next();
  }

  if (user.loginType === 'teacher') {

    if (to.name === 'teacherDashboard' || to.name === 'employeeProfile') return next();

    if (user.roleLabels.some(role => !restrictedRoles.includes(role))) {
      return next();
    } else {
      return next({ name: 'teacherDashboard' });
    }
  }

  return next();
};

export default routes; 